import { createRouter, createWebHistory } from 'vue-router'
import { isLoggedIn } from '@/lib/authentication.js'
import { store } from '@/shared-store.js'
import settings from '@/lib/settings'

import RaceSelect from '@/views/race-select.vue'
import RegistrationSheet from '@/views/registration-sheet.vue'
import Login from '@/views/login.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/',
    name: 'home',
    redirect: () => {
      const reid = store.state?.activeRaceEventId || settings.activeRaceEventId
      return reid ? `/${reid}` : '/events'
    },
  },
  {
    path: '/events',
    name: 'events',
    component: RaceSelect,
  },
  {
    path: '/:raceEventId',
    name: 'raceEvent',
    redirect: to => ({
      name: 'registrationEvent',
      params: { raceEventId: to.params.raceEventId },
    }),
  },
  {
    path: '/:raceEventId/registration',
    name: 'registrationEvent',
    props: true,
    component: RegistrationSheet,
  },
  {
    path: '/:raceEventId/races/:raceId',
    name: 'registration',
    props: true,
    component: RegistrationSheet,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()
  if (to.name === 'login' && loggedIn) {
    next({ path: to.query.t || '/' })
  }
  else if (to.name !== 'login' && !loggedIn) {
    next({ name: 'login', query: { t: to.fullPath } })
  }
  else {
    next()
  }
})

router.afterEach((to) => {
  if (to.params.raceEventId) {
    const requestedRaceEventId = parseInt(to.params.raceEventId)
    if (requestedRaceEventId !== store.state.activeRaceEventId &&
        requestedRaceEventId !== store.state.requestedActiveRaceEventId) {
      store.setActiveRaceEvent(requestedRaceEventId)
    }
  }

  if (to.params.raceId) {
    store.setActiveRace(parseInt(to.params.raceId))
  }
})

export default router
